// import store from "@/state/store";
import middleware from "../middleware/middleware";

const meta = {
    middleware: middleware,
    // resource: 'Auth',
    redirectIfLoggedIn: true,
};

export default [
    {
        path: "/login",
        name: "login",
        component: () => import("@/views/auth/signin.vue"),
        meta: {
            ...meta,
            title: "Login",
        },
    },
    // {
    //     path: "/forgot-password",
    //     name: "Forgot password",
    //     component: () => import("@/views/account-ui/forgot-password.vue"),
    //     meta: {
    //         ...meta,
    //         title: "Forgot Password",
    //     },
    // },
]